import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import CoachLogin from '../components/auth/CoachLogin';
import CoachRegister from '../components/auth/CoachRegister';

const CoachLoginView = () => {
  const navigate = useNavigate();
  const { isAuthenticated, role, loading, signOut, authError, clearAuthError } = useAuth();
  const [currentScreen, setCurrentScreen] = useState('login'); // 'login' | 'register'
  const [loginError, setLoginError] = useState('');
  const [showErrorFromWrongRole, setShowErrorFromWrongRole] = useState(false);

  useEffect(() => {
    if (!loading && isAuthenticated && role && role !== 'coach') {
      signOut().then(() => {
        setShowErrorFromWrongRole(true);
        setLoginError('Correo o contraseña incorrectos. Intenta de nuevo.');
      });
    }
  }, [isAuthenticated, role, loading, signOut]);

  if (!loading && isAuthenticated && role === 'coach') {
    const qrRedirect = localStorage.getItem('qr_redirect');
    if (qrRedirect) {
      localStorage.removeItem('qr_redirect');
      return <Navigate to={qrRedirect} replace />;
    }
    return <Navigate to="/entrenadores/dashboard" replace />;
  }

  const handleBackToHome = () => {
    navigate('/');
  };

  const handleGoToRegister = () => {
    setCurrentScreen('register');
  };

  const handleBackToLogin = () => {
    setCurrentScreen('login');
  };

  if (currentScreen === 'register') {
    return (
      <CoachRegister
        onBackToHome={handleBackToHome}
        onBackToLogin={handleBackToLogin}
      />
    );
  }

  const forcedError = showErrorFromWrongRole ? loginError : (authError || '');

  return (
    <CoachLogin
      onBackToHome={handleBackToHome}
      onGoToRegister={handleGoToRegister}
      forcedError={forcedError}
      onErrorDisplayed={() => {
        setShowErrorFromWrongRole(false);
        clearAuthError();
      }}
    />
  );
};

export default CoachLoginView;
